import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import i18n from './i18n/i18n'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' // Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax

// у Vuesax нет глобальных настроек. пришлось манкипатчить notify
Vue.use(Vuesax)
const newNotify = Vue.prototype.$vs.notify.bind({})
Vue.prototype.$vs.notify = (options) => newNotify({ time: 10000, position: 'top-center', ...options })

// Theme Configurations
import '../themeConfig.js'

// ACL
import acl from './acl/acl'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vuesax Admin Filters
import './filters/filters'

// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// VeeValidate
import ru from 'vee-validate/dist/locale/ru'
import adds from '@/i18n/validate.ru.js'
import VeeValidate, { Validator } from 'vee-validate'

Vue.use(VeeValidate, {
  locale: 'ru',
  dictionary: {
    ru: ru
  }
})
Validator.localize(adds)
Validator.extend('fullName', value => {
  return /^(([ЁёА-я-]{2,})\s){1,3}([ЁёА-я-]{2,})$/.test(value)
})

// vue the mask
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

// Api service
import ApiService from '@/common/api.service'
import ErrorFilter from '@/common/error.filter'
Vue.filter('error', ErrorFilter)
ApiService.init()

import VueQrcode from '@chenfengyuan/vue-qrcode'
Vue.component(VueQrcode.name, VueQrcode)

// Feather font icon
require('./assets/css/iconfont.css')

// Kontur Metrika
import VueKMTracker from '@/common/km-tracker'
Vue.use(VueKMTracker)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  acl,
  render: h => h(App)
}).$mount('#app')
